import { render, staticRenderFns } from "./AdminTimepassesBase.vue?vue&type=template&id=2cfe144a&"
import script from "./AdminTimepassesBase.vue?vue&type=script&lang=js&"
export * from "./AdminTimepassesBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports